var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrewForAllSquiggle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.595,
    height: 48.156,
    viewBox: "0 0 101.595 48.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#fe7a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#f85876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44293"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1686",
    "data-name": "Group 1686",
    transform: "translate(-214.52 -540)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M8.957-1.378l-1.2-1.365A3.135,3.135,0,0,1,5.369-1.664c-1.755,0-2.7-1.183-2.7-3.133A2.73,2.73,0,0,1,5.33-7.826a3.036,3.036,0,0,1,2.249.949l1.17-1.365a4.4,4.4,0,0,0-3.419-1.4A4.72,4.72,0,0,0,.52-4.8,4.607,4.607,0,0,0,5.369.156,4.527,4.527,0,0,0,8.957-1.378ZM18.187,0,15.665-3.965a2.681,2.681,0,0,0,2.119-2.691c0-1.638-1.274-2.834-3.263-2.834H11.115V0H13.2V-4.485L15.834,0ZM15.7-6.656a1.113,1.113,0,0,1-1.183,1.209H13.2V-7.735h1.326A1.088,1.088,0,0,1,15.7-6.656ZM26.052,0V-1.755h-3.64v-2h3.2V-5.512h-3.2V-7.735h3.445V-9.49H20.332V0ZM39.52-9.49H37.414L36.231-4.42a9.337,9.337,0,0,0-.156,1s-.078-.689-.143-1L34.814-9.49H32.747l-1.04,5.07c-.078.39-.143,1-.143,1a9.336,9.336,0,0,0-.156-1L30.186-9.49H28.028L30.485,0h2.08l1.027-4.992c.065-.351.182-1.365.195-1.469.013.143.117,1.105.195,1.469L35.009,0h2.015Z",
    transform: "translate(214 588)",
    fill: "#fa8800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M6.058-7.735V-9.49H.975V0h2.08V-3.718H5.863V-5.473H3.055V-7.735ZM17.732-4.784a4.63,4.63,0,0,0-4.875-4.862,4.715,4.715,0,0,0-4.9,4.862A4.771,4.771,0,0,0,12.831.156,4.77,4.77,0,0,0,17.732-4.784Zm-2.145,0a2.9,2.9,0,0,1-2.756,3.12,2.95,2.95,0,0,1-2.73-3.12,2.9,2.9,0,0,1,2.756-3.042A2.817,2.817,0,0,1,15.587-4.784ZM27.079,0,24.557-3.965a2.681,2.681,0,0,0,2.119-2.691c0-1.638-1.274-2.834-3.263-2.834H20.007V0h2.08V-4.485L24.726,0ZM24.6-6.656a1.113,1.113,0,0,1-1.183,1.209H22.087V-7.735h1.326A1.088,1.088,0,0,1,24.6-6.656Z",
    transform: "translate(258 588)",
    fill: "#fff44b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    d: "M9.035,0,5.59-9.49h-2L.195,0h2.2l.741-2.392H6.019L6.747,0ZM5.5-4.147H3.679l.715-2.314c.091-.325.182-.715.195-.754.013.078.117.455.208.754ZM16.445,0V-1.755h-3.38V-9.49h-2.08V0Zm7.67,0V-1.755h-3.38V-9.49h-2.08V0Z",
    transform: "translate(291 588)",
    fill: "#07c87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    d: "M6.058-7.735V-9.49H.975V0h2.08V-3.718H5.863V-5.473H3.055V-7.735ZM17.732-4.784a4.63,4.63,0,0,0-4.875-4.862,4.715,4.715,0,0,0-4.9,4.862A4.771,4.771,0,0,0,12.831.156,4.77,4.77,0,0,0,17.732-4.784Zm-2.145,0a2.9,2.9,0,0,1-2.756,3.12,2.95,2.95,0,0,1-2.73-3.12,2.9,2.9,0,0,1,2.756-3.042A2.817,2.817,0,0,1,15.587-4.784ZM27.079,0,24.557-3.965a2.681,2.681,0,0,0,2.119-2.691c0-1.638-1.274-2.834-3.263-2.834H20.007V0h2.08V-4.485L24.726,0ZM24.6-6.656a1.113,1.113,0,0,1-1.183,1.209H22.087V-7.735h1.326A1.088,1.088,0,0,1,24.6-6.656Z",
    transform: "translate(259 588)",
    fill: "#00baef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "all",
    d: "M9.035,0,5.59-9.49h-2L.195,0h2.2l.741-2.392H6.019L6.747,0ZM5.5-4.147H3.679l.715-2.314c.091-.325.182-.715.195-.754.013.078.117.455.208.754ZM16.445,0V-1.755h-3.38V-9.49h-2.08V0Zm7.67,0V-1.755h-3.38V-9.49h-2.08V0Z",
    transform: "translate(292 588)",
    fill: "#fb3780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crew",
    d: "M8.957-1.378l-1.2-1.365A3.135,3.135,0,0,1,5.369-1.664c-1.755,0-2.7-1.183-2.7-3.133A2.73,2.73,0,0,1,5.33-7.826a3.036,3.036,0,0,1,2.249.949l1.17-1.365a4.4,4.4,0,0,0-3.419-1.4A4.72,4.72,0,0,0,.52-4.8,4.607,4.607,0,0,0,5.369.156,4.527,4.527,0,0,0,8.957-1.378ZM18.187,0,15.665-3.965a2.681,2.681,0,0,0,2.119-2.691c0-1.638-1.274-2.834-3.263-2.834H11.115V0H13.2V-4.485L15.834,0ZM15.7-6.656a1.113,1.113,0,0,1-1.183,1.209H13.2V-7.735h1.326A1.088,1.088,0,0,1,15.7-6.656ZM26.052,0V-1.755h-3.64v-2h3.2V-5.512h-3.2V-7.735h3.445V-9.49H20.332V0ZM39.52-9.49H37.414L36.231-4.42a9.337,9.337,0,0,0-.156,1s-.078-.689-.143-1L34.814-9.49H32.747l-1.04,5.07c-.078.39-.143,1-.143,1a9.336,9.336,0,0,0-.156-1L30.186-9.49H28.028L30.485,0h2.08l1.027-4.992c.065-.351.182-1.365.195-1.469.013.143.117,1.105.195,1.469L35.009,0h2.015Z",
    transform: "translate(215 588)",
    fill: "#7d3bd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.828,22.74A4.831,4.831,0,0,1,.465,15.847C1.111,14.483,7.1,2.456,18.239.383c6.5-1.2,12.981,1.228,19.282,7.232,4.162,3.964,8.069,5.659,11.6,5.042,5.621-.984,10.134-7.7,11.272-9.984A4.834,4.834,0,0,1,69.039,7c-.269.535-6.7,13.163-18.254,15.184-6.722,1.179-13.427-1.369-19.933-7.564-3.92-3.733-7.561-5.325-10.821-4.73C14.661,10.867,10.39,17.518,9.195,20A4.843,4.843,0,0,1,4.829,22.74Z",
    transform: "translate(229.483 540)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrewForAllSquiggle);
export default __webpack_public_path__ + "static/media/crewForAll_squiggle.b5438ed09d9f38c38b41fa5c352c4395.svg";
export { ForwardRef as ReactComponent };